import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  required,
  useNotify,
} from "react-admin";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { TitleHomebaseWarehouse } from "./Constant/Constant";

const HomebaseWarehouseEdit = props => {
  const notify = useNotify();

  const onFailure = error => notify(error?.response?.data, { type: "warning" });

  return (
    <Edit {...props} title={TitleHomebaseWarehouse.edit} mutationMode="pessimistic" onFailure={onFailure}>
      <SimpleForm redirect={"/homebasewarehouses"}>
        <ReferenceInput
          label="Customer"
          source="customerId"
          reference={SourceCustomer}
          perPage={99999}
          sort={{ field: "id", order: "ASC" }}
          style={{ width: 400 }}
          validate={[required()]}
          disabled
        >
          <SelectInput optionValue="id" optionText="customerName" />
        </ReferenceInput>
        <TextInput source="location" style={{ width: 400 }} validate={[required()]} />
        <BooleanInput source="isActive" style={{ width: 400 }} defaultValue={true} />
      </SimpleForm>
    </Edit>
  );
};

export default HomebaseWarehouseEdit;
